












import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { DraggingOffsets } from "../../../../../base/domain/drawing";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { DragKinds } from "../../../../../base/components/dragging";
import { IFormatObjectEditable } from "../../../../domain/editableFormat";
import { FormatObjectEditableMixin } from "../mixins";
import {
  LineObjectDrawer,
  PositionCorrectionObjectDrawer,
  BoxLineObjectDrawer,
  CircleObjectDrawer,
  ImageObjectDrawer,
  ImageAreaObjectDrawer,
  BarcodeObjectDrawer,
  GraphObjectDrawer,
  CheckObjectDrawer,
  CircleSelectObjectDrawer,
  DateObjectDrawer,
  ScriptLinkObjectDrawer,
  CalculateObjectDrawer,
  JoinTextObjectDrawer,
  TagObjectDrawer,
  TextObjectDrawer,
  ScriptObjectDrawer,
  ComboObjectDrawer,
  RollObjectDrawer,
  NotImplementedObjectDrawer,
} from "./objects";

@Component({
  components: { // circleは予約語で使えない.2単語以上にするのがVue.jsのお作法らしいのでObjectを付ける.
    textObject: TextObjectDrawer,
    dateObject: DateObjectDrawer,
    tagObject: TagObjectDrawer,
    scriptObject: ScriptObjectDrawer,
    scriptlinkObject: ScriptLinkObjectDrawer,
    calculateObject: CalculateObjectDrawer,
    jointextObject: JoinTextObjectDrawer,
    checkObject: CheckObjectDrawer,
    circleselectObject: CircleSelectObjectDrawer,
    comboObject: ComboObjectDrawer,
    rollObject: RollObjectDrawer,
    imageareaObject: ImageAreaObjectDrawer,
    imageObject: ImageObjectDrawer,
    stampObject: NotImplementedObjectDrawer,            // Docu2Web未実装.E大でも使わないので優先度は低.
    graphObject: GraphObjectDrawer,
    embedObject: NotImplementedObjectDrawer,            // Claioシェーマ使わないので優先度は低.
    signObject: NotImplementedObjectDrawer,             // Docu2Web未実装.E大でも使わないので優先度は低.
    barcodeObject: BarcodeObjectDrawer,
    poscorrectObject: PositionCorrectionObjectDrawer,
    richTextObject: NotImplementedObjectDrawer,         // E大に出荷してるファイル版にはないので優先度は低.
    newLineObject: NotImplementedObjectDrawer,          // E大に出荷してるファイル版にはないので優先度は低.
    watermarkObject: NotImplementedObjectDrawer,        // DMO用なので優先度は低.
    variableareaObject: NotImplementedObjectDrawer,     // DMO用なので優先度は低.
    lineObject: LineObjectDrawer,
    boxlineObject: BoxLineObjectDrawer,
    circleObject: CircleObjectDrawer,
    triangleObject: NotImplementedObjectDrawer,         // 最新版でもフォーマット編集には機能なし.優先度低.
    crossObject: NotImplementedObjectDrawer,            // 最新版でもフォーマット編集には機能なし.優先度低.
  }
})
export default class FormatObjectDrawer extends Mixins(ModelEditableMixin, FormatObjectEditableMixin) {
  @Prop()
  offsets: DraggingOffsets<IFormatObjectEditable>;

  @Prop({ default: 1 })
  scale: number;

  @Prop({ default: true })
  isHandleable: boolean;

  @Emit()
  dragHandleSelected(event: PointerEvent, kind: DragKinds): void {}
}
